import {Logger} from '@practicegenius/domain/src/common/logger';
import * as React from 'react';

/**
 * A handler for catastrophic, unrecoverable errors
 * When an error is caught, this:
 * - logs the error with the given message
 * - renders the `errorNode`
 *
 * Because this exposes no way to clear the error,
 * the errorNode should instruct the user how to proceed
 */
export class CatastrophicErrorBoundary extends React.Component<
  {
    errorLogMessage: string;
    errorNode: React.ReactNode;
    logger: Logger;
    children?: React.ReactNode;
  },
  {
    hasError: boolean;
  }
> {
  static getDerivedStateFromError() {
    return {hasError: true};
  }

  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.props.logger.error(this.props.errorLogMessage, {error, errorInfo});
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorNode;
    }

    return this.props.children;
  }
}
